export function addCurrent(calledstatus) {
    return {
        type: 'ADD_CURRENT',
        calledstatus,
    }
}
